/**
 * D-1102-CREW-3: the Finish sheet needs its questions to open. With "The crew can save while offline" on, Today reads
 * them for each of the crew's open visits while there is a signal and keeps them for the day (this page only), so a
 * Finish can be filled in a dead spot.
 */
import type { QueryClient } from '@tanstack/react-query';
import type { FinishConfig } from '@shared/finish';
import { apiFetch } from '@/lib/api';

export function prefetchFinishConfig(qc: QueryClient, appointmentId: string): void {
  void qc.prefetchQuery({
    queryKey: ['finish-config', appointmentId],
    queryFn: () => apiFetch<FinishConfig>(`/api/finish/config?appointmentId=${encodeURIComponent(appointmentId)}`),
    staleTime: 10 * 60_000,
    gcTime: Infinity,
    retry: false,
  });
}
